import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import React from 'react';
import { Controlled_AutocompleteReferenceTextField } from './Controlled_AutocompleteReferenceTextField';
import {
    VideoAttachmentEditDialog,
} from '../../../page-components/project/reusable-elements/attachment/VideoAttachmentEditDialog';
import {
    VideoAttachmentCreationDialog,
} from '../../../page-components/project/reusable-elements/attachment/VideoAttachmentCreationDialog';
import { useVideoAttachmentActions } from '../../../../resource/resources/artifacts/attachment/videoAttachmentResource';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_VideoAttachmentTextField= ({objectId, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation}: {
    objectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    onChange?: (id: string | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    const nestedDialog = useNestedDialogFunction();

    const videoAttachmentActions = useVideoAttachmentActions()
    const systemInformationActions = useSystemInformationActions()
    const videoAttachmentsQuery = videoAttachmentActions.useGetAllResources(projectVersionId);
    const propertyDetails = systemInformationActions.useGetPropertyDetails(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType
    );
    const propertyValidation = systemInformationActions.useGetPropertyValidationWithId(
        propertyValidationInformation.propertyIdentifier,
        propertyValidationInformation.resourceType,
        propertyValidationInformation.resourceId ?? ''
    );

    const onEdit = () => {
        nestedDialog.showNestedDialog(
            <VideoAttachmentEditDialog
                onClose={nestedDialog.closeNestedDialog}
                objectId={objectId}
                versionedInId={projectVersionId ?? ""}
            />
        );
    };

    const onAdd = () => {
        nestedDialog.showNestedDialog(
            <VideoAttachmentCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={projectVersionId ?? ""}
                onCreated={(_, newObjectId) => {
                    if (onChange) {
                        onChange(newObjectId);
                    }
                }}
            />
        );
    };

    return (
        <Controlled_AutocompleteReferenceTextField
            idValue={objectId}
            readOnly={readOnly}
            onChange={onChange}
            propertyValidation={propertyValidation}
            propertyDetails={noLabel ? undefined : propertyDetails}
            query={videoAttachmentsQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
            onAdd={onAdd}
            onEdit={onEdit}
        />
    );
};
